// extracted by mini-css-extract-plugin
export default {"root":"cXwI__Xt14bXXHIcFH0w","wrap":"Kk4_KGZ_SVuMS8P7djHM","main":"fY20mL3IQvErai8FtYmE","icon":"oSJbGzCrgZWCl6AVIkci","divider":"t5DKQWZ9VEgq0uhcI2NN"};